var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 52,
  cy: 52,
  r: 52,
  fill: "#EFF4F1"
});

var _ref3 = /*#__PURE__*/React.createElement("mask", {
  id: "mask0",
  "mask-type": "alpha",
  maskUnits: "userSpaceOnUse",
  x: 0,
  y: 0,
  width: 104,
  height: 104
}, /*#__PURE__*/React.createElement("circle", {
  cx: 52,
  cy: 52,
  r: 52,
  fill: "#EFF4F1"
}));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask0)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M25.0005 45.8273C25.0005 38.9595 28.7805 32.6601 34.811 29.4777L82.9303 4.08501C83.4173 3.82808 84.0005 4.18451 84.0005 4.73901V101.262C84.0005 101.67 83.6731 102 83.2692 102H25.7318C25.3279 102 25.0005 101.67 25.0005 101.262V45.8273Z",
  fill: "url(#paint0_linear)",
  fillOpacity: 0.1
}), /*#__PURE__*/React.createElement("path", {
  d: "M48.0005 57.5114C48.0005 50.6165 51.8138 44.2928 57.8962 41.1018L118.923 9.08507C119.413 8.8277 120 9.18535 120 9.74147V127.26C120 127.669 119.671 128 119.264 128H48.7373C48.3304 128 48.0005 127.669 48.0005 127.26V57.5114Z",
  fill: "url(#paint1_linear)",
  fillOpacity: 0.1
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.1885 27.2489L-17.3335 55.815L-10.8512 62.3073L11.1885 40.2335L33.2284 62.3073L39.7106 55.815L11.1885 27.2489Z",
  fill: "white"
}));

var _ref5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear",
  x1: 60.6887,
  y1: 52.7602,
  x2: 25.0005,
  y2: 52.7602,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#94B4A4",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#94B4A4"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint1_linear",
  x1: 91.5522,
  y1: 68.2599,
  x2: 48.0005,
  y2: 68.2599,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#94B4A4",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#94B4A4"
})));

function SvgPatientPhotoEmpty(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 104,
    height: 104,
    viewBox: "0 0 104 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPatientPhotoEmpty);
export default __webpack_public_path__ + "static/media/patient-photo-empty.65e378067bca65e5829192ad512bb961.svg";
export { ForwardRef as ReactComponent };